import React from "react";
import {
  PublishBanner,
  Navigation,
  Footer,
  SiteMap,
  CopyrightLabel,
  OutboundLink,
  FishermanBanner,
} from "@bluefin/components";
import { graphql, StaticQuery } from "gatsby";

import "semantic-ui-less/semantic.less";

export default ({ children }) => (
  <StaticQuery
    query={graphql`
      query {
        fishermanBusiness {
          _id
          type
          name
          leadSource
          collectionMethod
          website {
            cloudformationStackName
          }
          gatsbyLogo {
            childImageSharp {
              fixed(height: 60) {
                base64
                width
                height
                src
                srcSet
              }
            }
          }
        }
        allFishermanBusinessWebsitePage(
          sort: { order: ASC, fields: navigationPriority }
        ) {
          nodes {
            title
            slug
            pageType
            url
            navigationPriority
            groupName
            props
          }
        }
      }
    `}
    render={(data) => {
      const { fishermanBusiness, allFishermanBusinessWebsitePage } = data;

      return (
        <React.Fragment>
          <div className={"site-container"}>
            <div>
              <PublishBanner
                business={{
                  id: fishermanBusiness._id,
                  type: fishermanBusiness.type,
                  name: fishermanBusiness.name,
                  leadSource: fishermanBusiness.leadSource,
                  collectionMethod: fishermanBusiness.collectionMethod,
                }}
                defaultDomain={
                  fishermanBusiness.website.cloudformationStackName
                }
                defaultShowBanner={true}
                collectEmail={false}
                enablePopup={true}
              />
              <Navigation
                links={allFishermanBusinessWebsitePage.nodes}
                bordered={false}
                centerMobileNavItems={true}
                fixed={false}
                header={fishermanBusiness.name}
                logo={fishermanBusiness.gatsbyLogo.childImageSharp}
                linksAs={"text"}
                primaryContentCentered={false}
              />
            </div>
            <div className={"page-container"}>{children}</div>
            <Footer
              backgroundColor={"primary"}
              horizontalAlign={"center"}
              verticalAlign={"middle"}
              columns={[
                <div />,
                <div>
                  <SiteMap
                    links={allFishermanBusinessWebsitePage.nodes}
                    horizontal={true}
                    bulleted={false}
                  />
                  <CopyrightLabel
                    company={fishermanBusiness.name}
                    phrase={"All Rights Reserved"}
                    privacyPolicyLink={
                      <OutboundLink
                        to={
                          "https://fisherman-static.s3.amazonaws.com/public/__fisherman/Client+Website+Privacy+Policy.pdf"
                        }
                        label={"Privacy Policy"}
                        eventLabel={"copyright-privacy-policy"}
                      />
                    }
                  />
                </div>,
                <div />,
              ]}
            />
          </div>
          <FishermanBanner />
        </React.Fragment>
      );
    }}
  />
);
